import type { RadioItemProps } from '@bos/ui';
import { RadioItem } from '@bos/ui';

export type AppBaseRadioItemProps = RadioItemProps;

/** Use AppRadioItem instead of AppBaseRadioItem, it should be used only within packages like mobility-ui */
export const AppBaseRadioItem = (props: AppBaseRadioItemProps) => (
	<RadioItem {...props} />
);
